// extracted by mini-css-extract-plugin
export default {"stickycontainer":"styles_stickycontainer__G08Ju"};